// extracted by mini-css-extract-plugin
module.exports = {"image":"BikeImage_image__0AxMz","disclaimer":"BikeImage_disclaimer___4X_T","checkList":"BikeImage_checkList__IS996","uspIcon":"BikeImage_uspIcon__rvw2D"};